/* FTP sticky cart + Buy now (16 Oct 2026).
   1. Sticky cart: once anything is in the cart, a bar shows the item count, the total, how far off free UK
      delivery is (£30), a View button (opens the cart drawer) and Checkout. Phones: full-width bar at the bottom,
      in place of the page's own sticky bar (homepage System bar, product page add-to-cart bar). Desktop: a card in
      the bottom-left corner. Hidden on /cart and while the drawer is open. Kept current by ftp-cart-sync.js.
   2. Buy now: [data-ftp-buynow="<variant id>"] buttons (product cards) add one (or the trade minimum in data-ftp-qty) and go straight to checkout.
      Product pages get a full-width Buy now button under the Add to Cart row (above Shop Pay) that adds the chosen flavour, quantity and
      Subscribe & Save choice, then goes straight to checkout. Not on Power Endurance System pages. */
(function () {
  if (window.__ftpStickyCart) return;
  window.__ftpStickyCart = true;

  var FREE = 3000;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function money(p) { return '£' + (p / 100).toFixed(2); }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  var css = [
    '.ftp-cartbar{position:fixed;left:0;right:0;bottom:0;z-index:40;display:none;align-items:center;gap:1rem;padding:1rem 1.4rem calc(1rem + env(safe-area-inset-bottom,0px));background:#141413;color:#fff;box-shadow:0 -6px 20px rgba(0,0,0,.18);font-family:"DM Sans",sans-serif}',
    'body.ftp-cartbar-on .ftp-cartbar{display:flex}',
    'body:has(cart-drawer.active) .ftp-cartbar{display:none !important}',
    '.ftp-cartbar__meta{flex:1 1 auto;min-width:0;line-height:1.25}',
    '.ftp-cartbar__line1{display:block;font-size:1.5rem;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.ftp-cartbar__line2{display:block;font-size:1.2rem;opacity:.85;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.ftp-cartbar__line2.is-free{color:#9be27a;opacity:1}',
    '.ftp-cartbar__view{flex:0 0 auto;appearance:none;background:transparent;color:#fff;border:1px solid rgba(255,255,255,.5);border-radius:10rem;padding:1.1rem 1.4rem;font:600 1.3rem/1 "DM Sans",sans-serif;cursor:pointer}',
    '.ftp-cartbar__go{flex:0 0 auto;display:inline-flex;align-items:center;background:#F7D400;color:#141413 !important;border-radius:10rem;padding:1.2rem 1.8rem;font:700 1.35rem/1 "Roboto Mono",monospace;letter-spacing:.04em;text-transform:uppercase;text-decoration:none}',
    'body.ftp-cartbar-on .ftp-sticky{display:none !important}',
    '@media (max-width:989px){body.ftp-cartbar-on shopify-chat{top:0 !important;bottom:calc(72px + env(safe-area-inset-bottom,0px)) !important;height:auto !important}body.ftp-cartbar-on{padding-bottom:72px}}',
    '@media (max-width:420px){.ftp-cartbar__view{display:none}}',
    '@media (min-width:990px){.ftp-cartbar{left:2rem;right:auto;bottom:2rem;width:42rem;border-radius:16px;padding:1.4rem 1.6rem}}',
    '.ftp-buynow{display:flex;align-items:center;justify-content:center;width:100%;min-height:4.8rem;margin-top:.8rem;border:0;border-radius:10rem;background:#141413;color:#fff !important;font:700 1.45rem/1 "Roboto Mono",monospace;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;text-decoration:none}',
    '.ftp-buynow[aria-busy="true"]{opacity:.6}',
    '.ftp-card .ftp-buynow{min-height:42px;padding:0 12px;margin-top:0;font-size:13px;letter-spacing:.04em}',
    '@media (min-width:461px){.ftp-card__foot:has(.ftp-buynow){flex-wrap:wrap}.ftp-card__foot:has(.ftp-buynow)>div:first-child{flex:1 0 100%}.ftp-card__foot:has(.ftp-buynow) .ftp-add,.ftp-card__foot .ftp-buynow{flex:1 1 0;width:auto}}'
  ].join('\n');

  function addStyle() {
    if (document.getElementById('ftp-cartbar-css')) return;
    var s = document.createElement('style'); s.id = 'ftp-cartbar-css'; s.textContent = css;
    document.head.appendChild(s);
  }

  var bar;
  function build() {
    bar = document.createElement('div');
    bar.className = 'ftp-cartbar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Your cart');
    bar.innerHTML = '<div class="ftp-cartbar__meta"><span class="ftp-cartbar__line1"></span><span class="ftp-cartbar__line2"></span></div>' +
      '<button type="button" class="ftp-cartbar__view">View</button>' +
      '<a class="ftp-cartbar__go" href="' + root() + 'checkout">Checkout</a>';
    bar.querySelector('.ftp-cartbar__view').addEventListener('click', function () {
      var d = document.querySelector('cart-drawer');
      if (d && d.open && document.getElementById('CartDrawer')) d.open(); else location.href = root() + 'cart';
    });
    document.body.appendChild(bar);
  }

  function paint(cart) {
    if (!bar) return;
    var n = cart && cart.item_count || 0;
    var on = n > 0 && !onCartPage();
    document.body.classList.toggle('ftp-cartbar-on', on);
    if (!on) return;
    bar.querySelector('.ftp-cartbar__line1').textContent = n + (n === 1 ? ' item' : ' items') + ' · ' + money(cart.total_price);
    var l2 = bar.querySelector('.ftp-cartbar__line2');
    if (cart.total_price >= FREE) { l2.textContent = 'Free UK delivery'; l2.classList.add('is-free'); }
    else { l2.textContent = money(FREE - cart.total_price) + ' to free UK delivery'; l2.classList.remove('is-free'); }
  }

  function load() {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {});
  }

  /* Buy now on product cards and anything else carrying data-ftp-buynow */
  function goCheckout() { location.href = root() + 'checkout'; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ftp-buynow]');
    if (!b || !window.Shopify) return;
    var id = b.getAttribute('data-ftp-buynow'); if (!id) return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Math.max(1, Math.floor(Number(b.getAttribute('data-ftp-qty')) || 1)) }] })
    }).then(function (r) { if (!r.ok) throw 0; goCheckout(); })
      .catch(function () { b.removeAttribute('aria-busy'); location.href = b.getAttribute('href') || root() + 'cart'; });
  });

  /* Buy now under the product page Add to Cart button */
  function pdpBuyNow() {
    if (!/\/products\//.test(location.pathname) || /power-endurance-system/.test(location.pathname)) return;
    var form = document.querySelector('#MainContent product-form form[action*="/cart/add"]') || document.querySelector('#MainContent form[action*="/cart/add"][data-type="add-to-cart-form"]');
    if (!form || form.querySelector('.ftp-buynow')) return;
    var add = form.querySelector('button[name="add"]'); if (!add) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ftp-buynow';
    btn.textContent = 'Buy now';
    var row = add.closest('.product-form__buttons-row');
    (row || add).insertAdjacentElement('afterend', btn);
    function sync() { btn.disabled = add.disabled || add.getAttribute('aria-disabled') === 'true'; btn.style.opacity = btn.disabled ? '.5' : ''; }
    sync();
    if (window.MutationObserver) new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      fd.delete('sections'); fd.delete('sections_url');
      if (!fd.get('quantity')) fd.set('quantity', '1');
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'error'); return j; }); })
        .then(goCheckout)
        .catch(function (err) {
          btn.removeAttribute('aria-busy');
          var msg = form.closest('product-info, .product') && document.querySelector('.product-form__error-message');
          if (msg) { msg.textContent = err.message; var w = msg.closest('.product-form__error-message-wrapper'); if (w) w.removeAttribute('hidden'); }
        });
    });
  }

  function start() {
    addStyle(); build(); load(); pdpBuyNow();
    document.addEventListener('ftp:cart-synced', function (e) { paint(e.detail); });
    document.addEventListener('ftp:cart-updated', function (e) { paint(e.detail); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) load(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
